import { Link, generatePath } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CompactAlert from "@/components/CompactAlert";
import { Button } from "@/components/ui/button";
import { Module, PATH_PROJECT_PERIOD_CONFIRMATION } from "@/constants";
import { useModulePermissions } from "@/modules/account/hooks/useModulePermissions";
import { ClockCheckIcon } from "lucide-react";

interface PeriodConfirmationAlertProps {
  projectId: string;
  show?: boolean;
}

export const PeriodConfirmationAlert = ({
  projectId,
  show,
}: PeriodConfirmationAlertProps) => {
  const { t } = useTranslation();
  const canRead = useModulePermissions(
    Module.ProjectPeriodConfirmations,
  ).can_read;

  if (!show || !canRead) {
    return null;
  }

  return (
    <CompactAlert
      variant="warning"
      message={t("projectPeriodConfirmation.alert")}
      actions={
        <Button asChild size="sm" variant="link" className="text-orange-600">
          <Link
            to={generatePath(PATH_PROJECT_PERIOD_CONFIRMATION, { projectId })}
          >
            <ClockCheckIcon />
            {t("projects.menubar.project.periodConfirmation")}
          </Link>
        </Button>
      }
    />
  );
};
